import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ClientOrdersActivePage } from '../clientPortal/pages/ClientOrdersActivePage';
import { ClientOrderRouter } from './ClientOrderRouter';
import { useLoginRedirect } from 'store/authentication/useLoginRedirect';
import { Redirect, useRouteMatch } from 'react-router';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';
import { eAccessControlUserType } from '../ui-toolkit/enums/eAccessControlUserType';
import { PageNotFound } from '../ui-toolkit';

export const ClientRoutes: React.FC = () => {
  const goLoginRedirect = useLoginRedirect();
  const { path } = useRouteMatch();

  return (
    <AccessControlCheck
      allowedPermissions={[ePermissions.ReadClientPortal]}
      actionOnFailure={() => goLoginRedirect(eAccessControlUserType.Client)}
    >
      <Switch>
        <Route path={`${path}`} exact render={({ location: { pathname } }) => <Redirect to={`${pathname}/orders`} />} />
        <Route path={`${path}/orders`} component={ClientOrdersActivePage} />
        <Route path={`${path}/order`} component={ClientOrderRouter} />
        <Route component={PageNotFound} />
      </Switch>
    </AccessControlCheck>
  );
};
